
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 7H20V10H2V7ZM11.1 17C11.0344 16.6769 11 16.3425 11 16C11 15.2889 11.1484 14.6125 11.416 14H2V17H11.1ZM14.8182 15.5455L17.5455 11L20.2727 15.5455H14.8182ZM19.8182 21C21.0734 21 22.0909 19.9825 22.0909 18.7273C22.0909 17.4721 21.0734 16.4545 19.8182 16.4545C18.563 16.4545 17.5455 17.4721 17.5455 18.7273C17.5455 19.9825 18.563 21 19.8182 21ZM13 17.3636V21H16.6364V17.3636H13Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionfloweControlFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
